export const getIdFromPath = (url) => {
  const path = url.split("/").pop();
  const idArray = path.split("-");
  return idArray;
};
